import { JSON_SCHEMA_CLIENT } from 'services/API';
import { Endpoints } from 'UI/constants/endpoints';

export const saveCandidateDataSheet = async dataSheet => {
  return JSON_SCHEMA_CLIENT.put(`/${Endpoints.CandidateDataSheetSave}`, dataSheet);
};
/**
 * @param {string} candidateId
 * @param {import('axios').AxiosRequestConfig} [config]
 */
export const getDataSheetByCandidateId = (candidateId, config) => {
  return JSON_SCHEMA_CLIENT.get(
    `/${Endpoints.CandidateDataSheetByCandidateId.replace(':id', candidateId)}`,
    config
  );
};
